<template>
  <com-page>
    <com-card>
      <div class="mb-15px">
        <el-tabs v-model="activeName">
          <el-tab-pane label="基本信息" name="0"></el-tab-pane>
          <el-tab-pane label="充电订单" name="1"></el-tab-pane>
          <el-tab-pane label="充值订单" name="2"></el-tab-pane>
          <el-tab-pane label="钱包管理" name="3"></el-tab-pane>
        </el-tabs>
      </div>

      <div class="mt-20px">
        <the-user-detail
          :code="userCode"
          :info="userInfo"
          v-if="activeName === '0'"
        ></the-user-detail>
        <div v-if="activeName === '1'">
          <com-order-search type-of-view="user" @search="handleSearch"></com-order-search>
          <com-order-list
            ref="table"
            :defaultParams="{ refUser: userCode }"
            type-of-view="user"
          ></com-order-list>
        </div>
        <div v-if="activeName === '2'">
          <com-recharge-search type-of-view="user" @search="handleSearch"></com-recharge-search>
          <com-recharge-list
            :userCode="userCode"
            type-of-view="user"
            ref="table"
          ></com-recharge-list>
        </div>
        <div v-if="activeName === '3'">
          <the-user-wallet-flow :userCode="userCode"></the-user-wallet-flow>
        </div>
      </div>
    </com-card>
  </com-page>
</template>

<script>
import utils from 'my-tools-library'
import theUserDetail from './components/the-user-detail'
import TheUserWalletFlow from './components/the-user-walletFlow'

export default {
  components: { theUserDetail, TheUserWalletFlow },
  data() {
    return {
      activeName: '0',
      userCode: '',
      userInfo: {}
    }
  },
  methods: {
    handleSearch(val) {
      this.$refs.table.search(val)
    }
  },
  created() {
    const { row } = this.$route.params
    if (utils.isEmptyObj(this.$route.params)) {
      this.$router.push({ name: 'user-index' })
      return
    }
    this.userCode = row.code
    this.userInfo = { ...row }
  }
}
</script>

<style lang="scss" scoped></style>
